import angular from 'angular';
import OktaAuthJs from '@okta/okta-auth-js';

import './authentication';

const SSO_AUTH_TYPE = "BEARER";

angular.module("merchant.application.main").factory("oktaAuth", [
    "core.application.main.controller.environment",
    function(Environment) {
        let _client = null;

        const client = function () {
            if(_client === null) {
                _client = new OktaAuthJs({
                    issuer: Environment.MERCHANT_PORTAL_OKTA_ISSUER,
                    features: {
                        idpDiscovery: true
                    },
                    authParams: {
                        display: 'page'
                    },
                    clientId: Environment.MERCHANT_PORTAL_OKTA_CLIENT_ID,
                });
            }
            return _client;
        }

        return { client };
    }
]);

angular.module("merchant.application.main").factory("merchantEmails", [
    "$http",
    "core.application.main.controller.environment",
    function($http, Environment) {

        const apiEndpoint = Environment.MERCHANT_PORTAL_API_BASE_URL;
        const emailLookupEndpoint = apiEndpoint + "/portal/merchants/emails/lookup";

        const emailLookup = (username) => {
            return $http({
                method: "POST",
                url: emailLookupEndpoint,
                data: {
                    email: username
                },
                excludeFromLoading: true,
            });
        };

        return { emailLookup };
    }
]);

angular.module("merchant.application.main").factory("merchant.application.main.factory.okta", [
    "core.application.main.factory.feature",
    "core.application.main.controller.environment",
    "oktaAuth",
    "merchantEmails",
    function(Feature, Environment, OktaAuth, MerchantEmails) {

        let _loginError = null;

        const isFeatureEnabled = () => {
            return Feature.retrieveFeatureFlagPromise(
                'merchant-portal-fe-login-okta',
                false
            );
        }

        const isUsernameSSOEnabled = (username) => {
            return MerchantEmails.emailLookup(username)
                .then((response) => {
                    if(response.data.authType === SSO_AUTH_TYPE) {
                        return true;
                    }
                    return false;
                }).catch(() => {
                    return false;
                });
        }

        const login = (username, redirectUri) => {
            OktaAuth.client().token.getWithRedirect({
                loginHint: username,
                redirectUri: redirectUri,
            });
        };

        const logout = async () => {
            const idToken = await OktaAuth.client().tokenManager.get("idToken");
            const token = idToken && idToken.value;
            await OktaAuth.client().revokeAccessToken();
            try {
                // https://github.com/okta/okta-auth-js/tree/3.2#closesession
                // this method needs third party cookies enabled
                // and will fail if they are not 
                await OktaAuth.client().closeSession();
            } catch (e) {
                console.warn(e);
            }
            return token;
        }

        const handleOktaRedirect = () => {
            if(!OktaAuth.client().token.isLoginRedirect()) {
                return Promise.resolve(false);
            }

            return OktaAuth.client().token.parseFromUrl()
                .then((res) => {
                    return {
                        username: res.tokens.idToken.claims.email,
                        accessToken: res.tokens.accessToken,
                        idToken: res.tokens.idToken
                    };
                })
                .catch((err) => {
                    return Promise.reject({err: err});
                });
        };

        const isEnabledForSSOLoginFlow = (username) => {
            if(!angular.isString(username)) {
                return Promise.resolve(false);
            }

            return isUsernameSSOEnabled(username);
        }

        const addToTokenManager = (name, value) => {
            OktaAuth.client().tokenManager.add(name, value);
        }

        const logoutRedirectUrl = function (token, redirectUri) {
            return `${Environment.MERCHANT_PORTAL_OKTA_ISSUER}/v1/logout?id_token_hint=${token}&post_logout_redirect_uri=${redirectUri}`
        }

        const loginError = function(error) {
            if (error === undefined) {
                return _loginError;
            }

            _loginError = error;
            return _loginError;
        };

        return {
            login,
            logout,
            handleOktaRedirect,
            loginError,
            logoutRedirectUrl,
            isEnabledForSSOLoginFlow,
            isFeatureEnabled,
            addToTokenManager,
        };
    }
]);
